module.exports = __webpack_public_path__ + "static/img/news1@2x.5f056ece.png";